import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FocusOutlineDirective } from 'src/app/accessibility/directives/focus-outline/focus-outline.directive';
import { ComponentsModule } from 'src/app/components/components.module';
import { CapAlertsPageService } from '../../../services/cap-alerts/cap-alerts-page.service';

@Component({
  selector: 'cap-alerts-connect-tab',
  templateUrl: './cap-alerts-connect-tab.component.html',
  styleUrl: './cap-alerts-connect-tab.component.scss',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ComponentsModule,
    FocusOutlineDirective,
  ],
})
export class CapAlertsConnectTabComponent {
  protected readonly pageService = inject(CapAlertsPageService);

  protected readonly helpUrl =
    'https://help.risevision.com/hc/en-us/articles/115005291946-Integrate-Your-CAP-Provider-to-Show-Emergency-and-Audio-Alerts';
}
